import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ roles, children, loginPath = "/login" }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  // Customer app: only customer-protected routes exist here. Internal roles
  // live in the console app; if one lands here, send them across.
  const CONSOLE_URL = process.env.REACT_APP_CONSOLE_URL || "/console";
  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-marigold" />
      </div>
    );
  }
  if (!user) {
    const next = location.pathname + location.search;
    return <Navigate to={`${loginPath}?next=${encodeURIComponent(next)}`} replace />;
  }
  if (user.role !== "customer") {
    window.location.href = `${CONSOLE_URL}/login`;
    return null;
  }
  return children;
}

